import { Autocomplete, TextField } from "@mui/material";
import useApi from "_api/index";
import React, { useEffect, useMemo, useState } from "react";

const OptionProvince = ({ value, onChangeValue, ...props }) => {
  const [provinces, setProvinces] = useState([]);

  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const response = await useApi.province.getProvinceTH();
        if (response) {
          setProvinces(response.map((item) => item.name));
        }
      } catch (error) {
        console.error("Error fetching provinces:", error);
      }
    };

    fetchProvinces();
  }, []);

  return (
    <Autocomplete
      {...props}
      fullWidth
      options={provinces}
      value={value ? value : ""}
      onChange={(event, newValue) => {
        console.log("Selected province:", newValue);
        if (onChangeValue) {
          onChangeValue(newValue || "");
        }
      }}
      disableClearable
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder="เลือกจังหวัด"
          sx={{
            "& .MuiOutlinedInput-root": {
              bgcolor: "white",
              height: "40px",
            },
          }}
          error={props.error || false}
          helperText={props.helperText || ""}
        />
      )}
      sx={{ width: "100%" }}
    />
  );
};
export default OptionProvince;
